<template>
  <div class="empty-wrapper">
    <img src="../../assets/empty.png" alt="" class="empty-img" >
    <p class="empty-text" >{{emptyMsg}}</p>
  </div>
</template>

<script>
  export default {
    name: 'icon-svg',
    props: {
      height: {
        type: String
      },
      emptyMsg: {
        type: String,
        default:"暂无数据"
      }
    },
    computed: {

    }
  }
</script>

<style lang="less" scoped>

  .empty-text{
    position: absolute;
    left: 50%;
    top: calc(50% + 130px);
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #909399;
  }
  .empty-img{
    position: absolute;
    left: calc(50% - 220px);
    top: calc(50% - 130px);
  }

</style>
